import { createSelector } from 'reselect'
import { parseURLParams, removeTrailingSlash } from '@offerzen/pinata-shame'

const getLocation = state => state.router.location

export const urlPath = createSelector([getLocation], location => removeTrailingSlash(location.pathname))
export const urlParams = createSelector([getLocation], location => parseURLParams(location.search))
export const previousLocation = createSelector([getLocation], location => location.state?.previousLocation)
